export const PostalCodeComponent = {
    template: `
        <oo-input-container>
            <input
                autocomplete="billing postal-code"
                id="card-postal-code"
                maxlength="5"
                name="billing-zip"
                ng-model="$ctrl.currentPayment.postalCode"
                ng-required="true"
                type="tel"
                ui-mask-placeholder-char="space"
                ui-mask="99999"
                ui-options="$ctrl.options"
            />
            <label>Zip</label>
            <div ng-messages="$ctrl.form['billing-zip'].$error">
                <div ng-messages-include="generic-messages"></div>
                <div ng-message="mask">Enter a valid zip code</div>
            </div>
        </oo-input-container>
    `,
    bindings: {
        currentPayment: '=',
        form: '<'
    },
    controller: class {
        constructor() {
            'ngInject';
            // TODO consolidate common options.
            this.options = { clearOnBlur: false, allowInvalidValue: true, addDefaultPlaceholder: false };
        }
    }
};
